import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	edit: {
		countries: [],
		name: ''
	},
	isLoaded: true,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR MAIN_ITEM STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// ****************** FETCH GEOBLOCK_GROUPS_ITEM ******************
			case types.FETCH_GEOBLOCK_GROUPS_ITEM_LOADING:
				draft.isLoaded = false;
				return;

			case types.FETCH_GEOBLOCK_GROUPS_ITEM_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				return;

			case types.FETCH_GEOBLOCK_GROUPS_ITEM_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
